import { downloadChartExcel as downloadChartExcelApi } from "../api";

// Same blob -> temporary <a> -> click -> revoke pattern as
// utils/downloadReport.js, just pointed at the chart-export endpoint.
export const downloadChartAsExcel = async (countryCode, indicatorId, fileName) => {
  try {
    const { data } = await downloadChartExcelApi(countryCode, indicatorId);

    const url = window.URL.createObjectURL(data);

    const link = document.createElement("a");
    link.href = url;
    link.download = fileName || `${countryCode}_${indicatorId}.xlsx`;

    document.body.appendChild(link);
    link.click();
    link.remove();

    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error("Failed to download chart as Excel:", err);
  }
};

// Pure client-side — never touches the backend. `chartInstance` is the
// ref.current from react-chartjs-2's <Bar ref={chartRef} />, which Chart.js
// renders on a transparent canvas (no title baked in — that's a separate
// DOM element in BarChart.js).
export const downloadChartAsImage = (chartInstance, title, fileName) => {
  if (!chartInstance) return;

  const sourceCanvas = chartInstance.canvas;
  const dpr = window.devicePixelRatio || 1;
  const titleHeight = title ? Math.round(48 * dpr) : 0;

  const canvas = document.createElement("canvas");
  canvas.width = sourceCanvas.width;
  canvas.height = sourceCanvas.height + titleHeight;

  const ctx = canvas.getContext("2d");

  // White background (the chart canvas itself is transparent).
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  if (title) {
    ctx.fillStyle = "#1A2233";
    ctx.font = `600 ${Math.round(20 * dpr)}px Inter, system-ui, sans-serif`;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(title, canvas.width / 2, titleHeight / 2);
  }

  ctx.drawImage(sourceCanvas, 0, titleHeight);

  const url = canvas.toDataURL("image/png");

  const link = document.createElement("a");
  link.href = url;
  link.download = fileName || "chart.png";

  document.body.appendChild(link);
  link.click();
  link.remove();
};
